import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Provider } from 'react-redux';
import store from './store';
import Home from './home';
import Login from './components/Login';
import ContactUs from './ContactUs';
import AboutUs from './AboutUs';
import Products  from './Products';
import CategoryList from './pages/categories/CategoryList';
import CategoryAdd from './pages/categories/CategoryAdd';
import CategoryEdit from './pages/categories/CategoryEdit';
import CategoryDelete from './pages/categories/CategoryDelete';
import CategoryProducts from './pages/categories/CategoryProducts';
import ProductList from './pages/products/ProductList';
import ProductAdd from './pages/products/ProductAdd';
import ProductEdit from './pages/products/ProductEdit';
import ProductDelete from './pages/products/ProductDelete';
import ScrollImages from "./components/Scroll_Image";

function App() {
  return (
    <Provider store={store}>
      <Router>
        {/* <Navbar /> */}
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Home />} />
          <Route path="/industries" element={<ScrollImages />} />
          <Route path="/contactus" element={<ContactUs />} />
          <Route path="/aboutus" element={<AboutUs />} />
          <Route path="/products" element={<ProductList />} />
          <Route path="/all-categories" element={<Products />} />
          <Route path="/products/add" element={<ProductAdd />} />
          <Route path="/products/edit/:id" element={<ProductEdit />} />
          <Route path="/products/delete/:id" element={<ProductDelete />} />
          <Route path="/categories" element={<CategoryList/>} />
          <Route path="/categories/add" element={<CategoryAdd/>} />
          <Route path="/categories/edit/:id" element={<CategoryEdit/>} />
          <Route path="/categories/delete/:id" element={<CategoryDelete/>} />
          <Route path="/categories/:id/products" element={<CategoryProducts/>} />
        </Routes>
      </Router>
    </Provider>
  );
}

export default App;
